import { defineSlotRecipe } from '@chakra-ui/react';
import { toastAnatomy } from '@chakra-ui/react/anatomy';

/**
 * Toast — UI kit web NOVAHEAL (float message / snackbar).
 * Figma: UI-kit-web-NOVAHEAL, node 18104-2144 (desktop 472px / mobile full width).
 * White surface, subtle border + shadow, status color on icon only; title 16px medium, body 14px.
 */
export const toastSlotRecipe = defineSlotRecipe({
  slots: toastAnatomy.keys(),
  className: 'nova-toast',
  base: {
    root: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      gap: 'xs',
      p: 's',
      minW: 0,
      w: { base: 'full', md: '472px' },
      maxW: 'full',
      borderRadius: 'm',
      borderWidth: '1px',
      borderColor: 'border.accent',
      bg: 'background.primary',
      color: 'text.primary',
      boxShadow: 'md',
      translate: 'var(--x) var(--y)',
      scale: 'var(--scale)',
      zIndex: 'var(--z-index)',
      height: 'var(--height)',
      opacity: 'var(--opacity)',
      willChange: 'translate, opacity, scale',
      transition: 'translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms',
      transitionTimingFunction: 'cubic-bezier(0.21, 1.02, 0.73, 1)',
      _closed: {
        transition: 'translate 400ms, scale 400ms, opacity 200ms',
        transitionTimingFunction: 'cubic-bezier(0.06, 0.71, 0.55, 1)',
      },
      '&[data-type=success], &[data-type=error], &[data-type=warning], &[data-type=info], &[data-type=loading]':
        {
          bg: 'background.primary',
          color: 'text.primary',
        },
    },
    indicator: {
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSize: '6',
    },
    title: {
      fontFamily: 'main',
      fontSize: 'm',
      fontWeight: 'medium',
      lineHeight: '130',
      letterSpacing: 'none',
      color: 'text.primary',
    },
    description: {
      fontFamily: 'main',
      fontSize: 's',
      fontWeight: 'regular',
      lineHeight: '140',
      letterSpacing: 'none',
      color: 'text.primary',
    },
    actionTrigger: {
      flexShrink: 0,
      alignSelf: 'center',
      height: 'auto',
      px: 'm',
      py: 'xs',
      borderRadius: 'l',
      borderWidth: '1px',
      borderColor: 'border.accent',
      borderStyle: 'solid',
      bg: 'background.primary',
      color: 'text.primary',
      fontFamily: 'main',
      fontSize: 's',
      fontWeight: 'regular',
      lineHeight: '140',
      transition: 'background 200ms, border-color 200ms',
      _hover: {
        bg: 'grey.50',
        borderColor: 'border.accent.hover',
      },
    },
    closeTrigger: {
      position: 'static',
      flexShrink: 0,
      alignSelf: 'center',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 'xs',
      borderRadius: 'm',
      color: 'icon.primary',
      transition: 'background 200ms',
      _hover: {
        bg: 'grey.100',
      },
      _icon: {
        boxSize: 'icon.m',
      },
    },
  },
});
